import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../lib/analytics";
import { reportPage } from "../lib/timeTracker";

/**
 * Envoie un page_view à GA4 à chaque changement de route.
 * Respecte le consentement (no-op si denied).
 * Signale aussi la route courante au tracker de temps (anonyme, backend).
 */
export default function PageViewTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search, document.title);
    reportPage(location.pathname);
  }, [location.pathname, location.search]);
  return null;
}
